// @flow
import * as React from 'react';

// Components
import { Container, Row, Col } from 'reactstrap';
import ButtonHeader from 'components/atoms/ButtonHeader';
import Button from 'components/atoms/Button';

import './SelfCheckInHeader.scss';

type Props = {
  label: string,
  route: string,
  buttonLabel?: string,
  onClick?: () => void,
  ariaLabel?: string
};

const ns = 'self-check-in-header';

export default function SelfCheckInHeader(props: Props) {
  const { label, route, buttonLabel, onClick, ariaLabel } = props;
  return (
    <Container>
      <Row>
        <Col xs={buttonLabel ? 6 : 12}>
          <ButtonHeader
            label={label}
            to={route}
            ariaLabel={ariaLabel}
            type={'back'}
          />
        </Col>
        {buttonLabel && (
          <Col xs={6} className={'text-right'}>
            <Button
              buttonTheme={'link'}
              className={`${ns}__button`}
              onClick={onClick}
            >
              {buttonLabel}
            </Button>
          </Col>
        )}
      </Row>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/atoms/SelfCheckInHeader/SelfCheckInHeader.js